import { FC } from 'react'
import 'project/polyfill'
import { useRouter } from 'next/router'

import { useUser } from 'common/services/useUser'
import { NextPageWithLayout } from '../types/nextPageWithLayout'
import LoginPage from './auth/login'
import { defaultLayout } from './_app'
import Head from 'next/head'
import SubscriptionInfoCard from 'components/project/cards/SubscriptionInfoCard'
import AccountStatusCard from 'components/project/cards/AccountStatusCard'
import OffersCard from 'components/project/cards/OffersCard'
import PageContainer from 'components/PageContainer'
import StatementsCard from 'components/StatementsCard'
import PhoneCard from 'components/project/cards/PhoneCard'
import { Project } from 'common/project'
import { ErrorMessage } from 'components/base/Messages'
import { useGetCompaniesQuery } from 'common/services/useCompany'
import { useFlags } from 'flagsmith/react'
import AddressCard from 'components/project/cards/AddressCard'
import { useUserData } from 'common/services/useUserData'
import MobileAppCard from 'components/project/cards/MobileAppCard'

export type HomePageType = {}

type DashboardType = {}

const Dashboard: FC<DashboardType> = ({}) => {
  const router = useRouter()
  const { data: companies } = useGetCompaniesQuery({})
  const { feature_kyc, feature_marketplace } = useFlags([
    'feature_marketplace',
    'feature_kyc',
  ])
  if (router.query.error) {
    return (
      <main className='container-fluid'>
        <Head>
          <title>{Project.siteName} | Login</title>
        </Head>

        {!!router.query.error && (
          <ErrorMessage className='text-center py-3'>
            You do not have access to the requested page, please check you are
            logged in with the correct account.
          </ErrorMessage>
        )}
      </main>
    )
  }

  const { userData } = useUserData({})
  return (
    <main className='container-fluid'>
      <Head>
        <title>{Project.siteName} | Dashboard</title>
      </Head>
      <h1 className='d-block mb-4 mt-2'>{`${
        userData?.first_name ? `Hey ${userData.first_name}` : 'Welcome back'
      }`}</h1>

      <div className='row'>
        {feature_kyc.enabled && (
          <AccountStatusCard className='col-xl-4 pb-4 col-lg-6 col-md-12' />
        )}
        <SubscriptionInfoCard className='col-xl-4 pb-4 col-lg-6 col-md-12' />
        <AddressCard className='col-xl-4 pb-4 col-lg-6 col-md-12' />
        {companies?.map((v) => (
          <PhoneCard
            key={v.id}
            company_id={v.id}
            className='col-xl-4 pb-4 col-lg-6 col-md-12'
          />
        ))}
        <StatementsCard className='col-xl-4 pb-4 col-lg-6 col-md-12' />
        <MobileAppCard className='col-xl-4 pb-4 col-lg-6 col-md-12' />
        {feature_marketplace.enabled && <OffersCard />}
      </div>
    </main>
  )
}

const HomePage: NextPageWithLayout<HomePageType> = ({}) => {
  const { data } = useUser({})
  const router = useRouter()
  if (!data) {
    return <LoginPage />
  } else {
    if (router.query.redirect) {
      router.replace(`${router.query.redirect}`)
      return null
    }
    return <Dashboard />
  }
}

HomePage.getLayout = (page, pageProps, user) => {
  return user ? defaultLayout(page) : <PageContainer>{page}</PageContainer>
}
export default HomePage
